module.exports = __webpack_public_path__ + "img/2804.8c5b1e3a.png";